import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, switchMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {environment} from '../environments/environment';

@Injectable()
export default class ReminderService {
  constructor(private http: HttpClient) {
  }

  addPushSubscriber(payload): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/users/webpush', payload).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
